import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { addUtils } from './class-name-helpers';

const gridClasses = ({
  horizontal,
  mdHorizontal,
  lgHorizontal,
  vertical,
  smVertical,
  wrap,
  nowrap,
  extent,
  center,
  equalWidth,
  mdEqualWidth,
  className,
  ...restProps
}) => ({
  classNames: clsx(
    'ss_grid',
    {
      'ss_grid--horizontal': horizontal,
      'md-ss_grid--horizontal': mdHorizontal,
      'lg-ss_grid--horizontal': lgHorizontal,
      'ss_grid--vertical': vertical,
      'sm-ss_grid--vertical': smVertical,
      'ss_grid--wrap': wrap,
      'ss_grid--nowrap': nowrap,
      'ss_grid--extent': extent,
      'ss_grid--center': center,
      'ss_grid--equal-width': equalWidth,
      'md-ss_grid--equal-width': mdEqualWidth,
    },
    className,
    addUtils(restProps).utilClassNames,
  ),
  ...restProps,
});

const Grid = ({ children, ...rest }) => {
  const { classNames, restProps } = gridClasses(rest);

  return (
    <div
      className={classNames}
      {...restProps}
    >
      {children}
    </div>
  );
};
Grid.defaultProps = {
  className: '',
};

Grid.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

const GridElement = ({ children, className, ...rest }) => {
  const { utilClassNames, restProps } = addUtils(rest);
  return (
    <div className={clsx('ss_grid_element', utilClassNames, className)} {...restProps}>
      {children}
    </div>
  );
};

GridElement.defaultProps = {
  className: '',
};
GridElement.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export { Grid, GridElement };
